import React, { useState, useRef } from 'react';
import classNames from 'classnames';
import { Lightswitch, Icons } from '../../../';
export const LayersPanel = ({ className, selected, layers, onSelect, translationData, }) => {
    const [isExpnaded, toggleExpnaded] = useState(false);
    let selectionArray = selected;
    const listRef = useRef(null);
    const caretUpIcon = React.createElement(Icons, { iconName: `ic-ui-caret-up`, size: "20" });
    const caretDownIcon = React.createElement(Icons, { iconName: `ic-ui-caret-down`, size: "20" });
    const updateSelection = item => {
        const { name } = item;
        const temp = [];
        let isFound = false;
        selectionArray.forEach(item => {
            if (item === name) {
                isFound = true;
            }
            else {
                temp.push(item);
            }
        });
        if (isFound) {
            selectionArray = temp;
        }
        else {
            selectionArray = [...temp, name];
        }
        onSelect(selectionArray);
    };
    // translation
    const { title, hide: hideText, showMore: showMoreText } = translationData;
    return (React.createElement("div", { className: classNames(className, `layers-panel`) },
        React.createElement("h3", { className: "layers-panel_title" }, title),
        React.createElement("div", { ref: listRef, className: classNames('layers-panel_selection', {
                'layers-panel_selection--min': !isExpnaded,
                'layers-panel_selection--overflow': layers.length > 12,
            }) }, layers.map((item, index) => {
            const { label, name, disabled = false } = item;
            const selectFlag = selected.indexOf(name) !== -1;
            return (React.createElement("div", { key: `${index}-${name}`, className: "layers-panel_switch" },
                React.createElement("div", { className: classNames(`layers-panel_label`, {
                        disabled,
                    }) },
                    React.createElement("span", { title: label || name }, label || name)),
                React.createElement(Lightswitch, { enabled: selectFlag, disabled: disabled, onClick: () => {
                        updateSelection(item);
                    } })));
        })),
        layers.length > 7 && (React.createElement("a", { className: "subtle-link", onClick: () => {
                toggleExpnaded(!isExpnaded);
                if (listRef && listRef.current) {
                    listRef.current.scrollTop = 0;
                }
            } },
            isExpnaded ? hideText : showMoreText,
            isExpnaded ? caretUpIcon : caretDownIcon))));
};
//# sourceMappingURL=LayersPanel.js.map